import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../../src/App.css";
import "../../src/index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import logo from "../logo-dark.svg";

import {
  faHome,
  faSackDollar,
  faIdCard,
} from "@fortawesome/free-solid-svg-icons";
import Can from "./Can";
// import { width } from "@fortawesome/free-brands-svg-icons/fa11ty";

function AdminNavbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const closeSidebar = () => {
    setIsOpen(false);
  };
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userType");
    localStorage.removeItem("userName");
    navigate("/login", { replace: true });
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <button className="menu-btn" onClick={toggleSidebar}>
            ☰
          </button>
          <div className="navbar-title">
            <img src={logo} alt="اللوجو" style={{ width: "30px" }} />
          </div>
        </div>
      </nav>

      {isOpen && <div className="overlay" onClick={closeSidebar}></div>}

      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        <button className="close-btn" onClick={closeSidebar}>
          ×
        </button>
        <ul>
          {/* <li className="section-title">النظام</li> */}
          <Can permission="admin_show">
            <button onClick={handleLogout} className="logout-btn mt-5">
              <FontAwesomeIcon icon={faSignOutAlt} /> تسجيل الخروج
            </button>

            <hr />

            <li>
              <NavLink
                to="/admin/sub-admins"
                onClick={closeSidebar}
                className={({ isActive }) => (isActive ? "active" : "")}>
                <FontAwesomeIcon icon={faHome} /> المستخدمون
              </NavLink>
            </li>
          </Can>
          <Can permission="subscriber_show">
            <li>
              <NavLink
                to="/admin/subscriptions"
                onClick={closeSidebar}
                className={({ isActive }) => (isActive ? "active" : "")}>
                <FontAwesomeIcon icon={faSackDollar} /> الإشتراكات
              </NavLink>
            </li>
          </Can>
          {/* <Can permission="admin_show">
            <li>
              <NavLink
                to="/admin/subscribtions-details"
                onClick={closeSidebar}
                className={({ isActive }) => (isActive ? "active" : "")}>
                <FontAwesomeIcon icon={faIdCard} /> تفاصيل المشتركين
              </NavLink>
            </li>
          </Can> */}
        </ul>
      </div>
    </>
  );
}

export default AdminNavbar;
